window.BOLD = window.BOLD || {};
window.BOLD.BMS = window.BOLD.BMS || {};
window.BOLD.BMS.ACCESSIBILITY = window.BOLD.BMS.ACCESSIBILITY || {};

BOLD.BMS.ACCESSIBILITY = (function ($) {
  var mobile = false;
  if( $(window).width() < 770 ) {
    mobile = true;
  }

  var executeHeader = function() {

  }


  var executeCommon = function() {

  // power mapper fixes start
    $('.yotpo-logo-link-new').attr('name', 'powered by Yotpo.  Go to Yotpo homepage');
    $('.bottom-line-items').attr('aria-label', 'product star rating');
    $('.yotpo-icon-down-arrow').prepend('<span class="sr-only">next review</span>');
    $('.yotpo-icon-up-arrow').prepend('<span class="sr-only">previous review</span>');
    $('.yotpo-pager').attr('role', 'list');

    // yotpo visual 'label' not in aria-label
    $('.text-m').each(function() {
      var visualLabel = $(this).text();
      var ariaLabel = $(this).attr('aria-label');
      $(this).attr('aria-label', ariaLabel + ', ' + visualLabel + ' reviews');
    });

    // multiple page descriptions have empty <h3> tags
    $('h3').each(function() {
      if( $(this).text() == '' ) {
        $(this).remove();
      }
    });

    // all of these autocomplete values are invalid
    $('#yotpo_input_review_title, .yotpo-text-box, #yotpo_input_review_username, .yotpo_input_review_email').each(function() {
      if( $(this).attr('autocomplete') == 'review-title' || $(this).attr('autocomplete') == 'review-content' || $(this).attr('autocomplete') == 'user-your-name' || $(this).attr('autocomplete') == 'your-email') {
        $(this).attr('autocomplete', 'off');
      }
    });

    // multiple page descriptions contain iframes that don't have title attributes
    $('iframe').each(function(i) {
      var title = $(this).attr('title');

      if (typeof title == typeof undefined || title == false) {
          $(this).attr('title', docTitle + ' video ' + (i + 1));
      }
    });

    $('.Article__Body a').each(function() {
      if( $(this).text() == 'read more' ) {
        $(this).append('<span class="sr-only"> on ' + docTitle + '</span>')
      }
    });

  // power mapper fixes end
    $('a, img, button, [tabindex="0"]').on('mousedown', function(event) {

      event.preventDefault();
    });
  }



  var executeProduct = function() {



  }



  var executeCollection = function() {

  }



  function evaluateKeyPress(e) {
      var code = e.keyCode || e.which;
      if(code == 13) {
        return 'enter';
      } else if (code == 9) {
        return 'tab'
      }
  }

  function checkForLoaded(attemptCount, el, fn) {
    var $elemSelector = $(el);

    if( $elemSelector.length > 0 ) {
        fn(el);
    } else {
      if( attemptCount < 100 ) {

        setTimeout(function() {
          attemptCount++;
            checkForLoaded(attemptCount, el, fn);
        }, 100);
      }
    }
  }

  function hideFromScreenReader(el) {
    $(el).attr('aria-hidden', 'true');
  }

  // This is for situations in which the same feedback may be given feedback repeatably.
  // usually the same string won't be used if its already in the element.
  // 'enabler' is a word that is to be inserted into the feedback element to essentially clear it.
  // 'enabler' is meant to contain a word that would otherwise be used at the end of a feedback string.
  // adding it a second after the initial feedback allows the element to be cleared so the same text can be inserted and read out again.
  function clearAudioFeedbackEl(enabler) {
    setTimeout(function() {
      $('.bms_audio_feedback').text(enabler);
    }, 1000);
  }


  // helper to administrate the audio feedback for trigger elements and their associated modals.
  function toggleDropdown($el, title) {
      $el.toggleClass('sr_opened');

      if( $el.hasClass('sr_opened') ) {
        $('.bms_audio_feedback').text(title + ' opened below');
        $el.attr('aria-label', 'Click to open or close ' + title + '.  ' + title + ' is now opened.')
      } else {
        $('.bms_audio_feedback').text(title + ' is now closed.');
        $el.attr('aria-label', 'Click to open or close ' + title + '.  ' + title + ' is now closed.')
      }
  }


  var init = function() {
    executeHeader();
    executeCommon();
    if( bms_template == 'product' ) {
      executeProduct();
    } else if( bms_template == 'collection' ) {
      executeCollection();
    }
  }

  return {
    init: init
  }

})(jQuery)

window.addEventListener('DOMContentLoaded', function(event){
  BOLD.BMS.ACCESSIBILITY.init();
});

